@if (badges.length) {
    <div [class.small]="small" class="badgeRow mt-10">
        @for (badge of badges; track trackByBadge(i, badge); let i = $index) {
            @if (!small || i < limit) {
                <div class="badge flex-space-between d-flex flex-col">
                    <div [matTooltipDisabled]="hideTooltip"
                         [matTooltip]="badge.name + (!showInProgress && badge.stack_count > 1? ' earned '+ badge.stack_count + ' times' : '')"
                         class="flex-col align-items-center">
                        @if (!small) {
                            <strong>{{ badge.name }}</strong>
                        }
                        <div [matBadgeHidden]="showInProgress ||!badge.stack_count || badge.stack_count < 2 "
                             [matTooltipDisabled]="!hideTooltip"
                             [matTooltip]="!showInProgress && badge.stack_count > 1? 'Earned '+ badge.stack_count + ' times' : ''"
                             [matBadge]="badge.stack_count || 0"
                             [matBadgeSize]="small? 'small':'large'"
                             [class.mt-15]="!showInProgress && !small">
                            <img [alt]="badge.name + ' badge'" [src]="badge.image" class="w-100">
                        </div>
                        @if (!small) {
                            <small>{{ badge.description }} {{ badge.stack_count }}</small>
                        }
                    </div>
                    <div>
                        @if (!small && showInProgress) {
                            <div class="customProgress badgeBar">
                                @for (requirement of badge.requirements; track requirement) {
                                    @if (requirement.quantity > 0 || requirement.updatedQuantity > 0) {
                                        <p [style.color]="this.themeService.getReadableColor(community?.badge_progress_slider_bg_color_hex)"
                                           class="current">{{ requirement.updatedQuantity || requirement.currentQuantity }}</p>
                                        <mat-progress-bar
                                                [style.border-color]="community?.badge_progress_slider_bg_color_hex"
                                                [value]="getPercent(requirement.updatedQuantity || requirement.currentQuantity || 0, requirement.quantity)"
                                                class="customProgress customBadgeProgressSlider"
                                                mode="determinate"></mat-progress-bar>
                                        <p class="required">{{ requirement.quantity }}</p>
                                    }
                                }
                            </div>
                        }
                    </div>
                </div>
            }
        }
    </div>
} @else {
    <div class="w-100 flex-row justify-content-center mt-15">
        @if (!allBadges.length) {
            <div>This community does not have any badges yet</div>
        }
        @if (allBadges.length && showInProgress && !inProgressBadges.length) {
            <div>Congratulations! You have all the
                badges!
            </div>
        }
        @if (allBadges.length && !showInProgress && !isMe) {
            <div class="muted">This user does not have any badges yet
            </div>
        }
        @if (allBadges.length && !showInProgress && isMe) {
            <div class="muted">You don't have any badges yet</div>
        }
    </div>
}

